import { NgModule }        from '@angular/core';
import { SectionsService } from './sections.service';

@NgModule({
  providers: [SectionsService]
})
export class SectionModule { }
